export default __webpack_public_path__ + "static/media/logo.6921f614.png";